import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { map } from 'rxjs';
import { PAGE } from '../../core';
import { UserService } from '../../services';
import { BaseComponent } from '../../shared';


/**
 * Component for template of list page.
 */
@Component({
	selector: 'list-template',
	templateUrl: './list-template.component.html',
	imports: [
		RouterLink,
		RouterLinkActive
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ListTemplateComponent extends BaseComponent {

	private readonly router = inject(Router);
	private readonly userSrv = inject(UserService);

	readonly isCustomerCare = toSignal(this.userSrv.isCustomerCare());
	readonly isArchiveVisible = toSignal(this.userSrv.getCurrentUser().pipe(map(usr => !!usr.isMigratedTLHEX)));
	readonly PAGE = PAGE;

	/**
	* Navigate to previous page.
	*/
	returnToPreviousPage(): void {
		this.router.navigateByUrl(`/${PAGE.DASHBOARD}`);
	}

}
